import Header from '../../components/common/header/index.vue'
import Bottom from '../../components/common/bottom/index.vue'
import axios from 'axios'
export default {
  name: 'help',
  components: { Header, Bottom },
  data () {
    return {
      treeList: [
        {
          label: '注册',
          id: 'zc',
          level: '1',
          children: [
            {
              label: '进入注册页面',
              id: 'zcym',
              level: '2'
            }, {
              label: '填写注册信息',
              id: 'zcxx',
              level: '2'
            }
          ]
        }, {
          label: '登录',
          id: 'login',
          level: '1'
        }, {
          label: '首页',
          id: 'index',
          level: '1',
          children: [
            {
              label: '数据驾驶舱',
              id: 'jsc',
              level: '2'
            }, {
              label: '业务导航',
              id: 'navi',
              level: '2'
            }
          ]
        }, {
          label: '英烈档案',
          id: 'ylda',
          level: '1'
        }, {
          label: '专题研究',
          id: 'ztyj',
          level: '1',
          children: [
            {
              label: '查看专题',
              id: 'ckzt',
              level: '2'
            }, {
              label: '专题详情',
              id: 'ztxq',
              level: '2',
              children: [
                {
                  label: '检索',
                  id: 'search',
                  level: '3'
                }, {
                  label: '更多',
                  id: 'more',
                  level: '3'
                }, {
                  label: '查看文章',
                  id: 'ckwz',
                  level: '3'
                }
              ]
            }
          ]
        }, {
          label: '精品文物',
          id: 'jpww',
          level: '1',
          children: [
            {
              label: '查看文物列表',
              id: 'wwlb',
              level: '2'
            }, {
              label: '查看文物详情',
              id: 'wwxq',
              level: '2',
              children: [
                {
                  label: '文物研究成果',
                  id: 'wwyjcg',
                  level: '3'
                }, {
                  label: '热点文物',
                  id: 'rdww',
                  level: '3'
                }
              ]
            }
          ]
        }, {
          label: '专家成果',
          id: 'zjcg',
          level: '1'
        }, {
          label: '机构成果',
          id: 'jgcg',
          level: '1'
        }, {
          label: '红色动态',
          id: 'hsdt',
          level: '1'
        }, {
          label: '后台管理系统',
          id: 'back',
          level: '1',
          children: [
            {
              label: '进入后台管理系统',
              id: 'goBack',
              level: '2'
            }, {
              label: '首页',
              id: 'backHome',
              level: '2'
            }, {
              label: '精品文物',
              id: 'backJpww',
              level: '2'
            }, {
              label: '专题研究',
              id: 'backZtyj',
              level: '2'
            }, {
              label: '系统管理',
              id: 'backXtgl',
              level: '2',
              children: [
                {
                  label: '账号管理',
                  id: 'zhgl',
                  level: '3'
                }, {
                  label: '部门管理',
                  id: 'bmgl',
                  level: '3'
                }, {
                  label: '岗位管理',
                  id: 'gwgl',
                  level: '3'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  // 创建元素
  mounted () {
  },
  // 方法定义
  methods: {
    // 树的点击
    handleNodeClick (data) {
      const top = document.getElementById(data.id).offsetTop
      document.getElementById('HelpContent').scrollTop = top
    }
  }
}
